import * as React from 'react';

import cn from 'classnames';

import { getRandomDefaultColor } from '@utils';

import { IEmptyAvatarProps } from './types';

import * as s from './EmptyAvatar.scss';

export const EmptyAvatar = (props: IEmptyAvatarProps) => {
	const { title, isCircle = true } = props;
	const initials = title
		.split(' ')
		.map((word) => word[0] || '')
		.join('')
		.slice(0, 2)
		.toUpperCase();

	return (
		<div
			className={cn(s.block, { [s.circle]: isCircle })}
			style={{ backgroundColor: getRandomDefaultColor() }}
		>
			<div className={s.initials}>{initials}</div>
		</div>
	);
};
